import React from 'react';
import { ResponsiveContainer } from 'recharts';

function ChartCard({ title, children }) {
    return (
        <div className="bg-white  rounded-[1.75rem] shadow-sm md:p-6 p-2">
            <h2 className="text-xl font-bold mb-4">{title}</h2>
            <ResponsiveContainer width="100%" height={300}>
                {children}
            </ResponsiveContainer>
        </div>
    );
}

export default ChartCard;